<template>
  <div class="content-wrapper component-color-selector">
    <div class="component-content-subtitle  mb-2">Select color</div>
    <div v-if="this.results.colour!=null && this.results.colour.type!=null && this.results.colour.type.id==993">
      You have choose a fully custom colour scheme
    </div>

    <div class="colors-wrapper" v-else>
      <div class="color-wrapper" v-if="primaryColor != null">
        <label :for="'stemPrimaryColor' + componentId" class="label-color">
          <img v-if="getColorByName(primaryColor) != null"
            :src="'/storage/' + getColorByName(primaryColor).image"
            alt=""
          />
          <input
            type="radio"
            name="color"
            class="stemPrimaryColor"
            v-model="colorInput"
            :value="primaryColor"
            :id="'stemPrimaryColor' + componentId"
          />
          <span class="checkmark"></span>
          <span class="color-desc">{{ primaryColor }}</span>
        </label>
      </div>
      <div class="color-wrapper" v-if="secondaryColor != null">
        <label :for="'stemSecondaryColor' + componentId" class="label-color">
          <img v-if="getColorByName(secondaryColor) != null"
            :src="'/storage/' + getColorByName(secondaryColor).image"
            alt=""
          />
          <input
            type="radio"
            name="color"
            class="stemSecondaryColor"
            v-model="colorInput"
            :value="secondaryColor"
            :id="'stemSecondaryColor' + componentId"
          />
          <span class="checkmark"></span>

          <span class="color-desc">{{ secondaryColor }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "component-color-selector",
  data() {
    return {};
  },
  props: ["primaryColor", "secondaryColor", "colors", "componentId", "componentType", "results"],
  computed: {
    colorInput: {
      get: function () {
        if (this.results[this.componentType]!=null && typeof this.results[this.componentType].colour=='undefined') {
          return null;
        }
        return this.results[this.componentType].colour;
      },
      set: function (e) {
        let color = this.getColorByName(e);

        // aggiorna il colore salvato in locale
        let currConfig = window.localStorage.getItem("currentBikeConfig");
        if(currConfig != null) {
          currConfig = JSON.parse(currConfig);
          if(currConfig.stem && currConfig.stem.value) {
            currConfig.stem.value.colour = color;
            currConfig = JSON.stringify(currConfig);
            window.localStorage.setItem("currentBikeConfig", currConfig);
          }
        }

        this.$emit("component-color-selected", color, this.componentId, this.componentType);
      },
    },
  },
  methods: {
    getColorByName: function (colorName) {
      for (const color of this.colors) {
        if (color.name == colorName) {
          return color;
        }
      }
      return null;
    }
  },
};
</script>

<style lang="scss" scoped>
.component-color-selector {
  .colors-wrapper {
    display: flex;
  }
  .color-wrapper {
    position: relative;
    font-size: 8px;
    max-width: 50px;
    margin-right: 20px;
    margin-bottom: 10px;
    text-align: center;
    letter-spacing: 1.25px;
    text-transform: uppercase;
    .general-title {
      font-size: 14px;
    }
    .label-color {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      border: none;
      position: relative;
      text-transform: uppercase;
      .color-desc {
        display: block;
        margin-top: 5px;
        width: 50px;
        margin-left: -7px;
      }
      img {
        width: 100%;
        mix-blend-mode: darken;
      }
        input {
          position: absolute;
          opacity: 0;
          cursor: pointer;
          height: 13px;
          width: 13px;
          left: 11px;
          top: 13px;
          z-index: 7;
          &:checked ~ .checkmark {
            background-color: #000000;
            &:after {
              display: block;
            }
          }
        }
        .checkmark {
          position: absolute;
          left: 11px;
          top: 15px;
          height: 13px;
          width: 13px;
          background-color: #F6F6F6;
          border-radius: 50%;
          cursor: pointer;
          &:after {
            content: "";
            position: absolute;
            display: none;
          }
        }
    }
  }

}
</style>